import './FontIcon.styl';

import type { FontIconName } from './names';

export type { FontIconName } from './names';

type Props = { name: FontIconName; className?: string };

/** Decorative glyph from the IcoMoon icon font; hidden from assistive technology. */
export function FontIcon({ name, className }: Props) {
  return <span className={`a-ficon icon-${name}${className ? ` ${className}` : ''}`} aria-hidden="true" />;
}
